import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import {
  SERVICE_INTERFACE_FILTERS_MESSAGES,
  ServiceInterfaceFiltersMessages,
} from "./service-interface-filters.messages";
import {
  SERVICE_INTERFACE_LOGS_MESSAGES,
  ServiceInterfaceLogsMessages,
} from "./service-interface-logs.messages";
import {
  SERVICE_INTERFACE_TABLE_MESSAGES,
  ServiceInterfaceTableMessages,
} from "./service-interface-table.messages";

export type ServiceInterfaceMessages = ServiceInterfaceFiltersMessages &
  ServiceInterfaceTableMessages &
  ServiceInterfaceLogsMessages &
  SidebarMessages & {
    pageTitle: string;
    tableTitle: string;
    integrationsBreadCrumb: string;
    errorToLoad: string;
    noDataFoundError: string;
    noDataFoundAlt: string;
    settingsModalTitle: string;
    settingsKeyColumn: string;
    settingsValueColumn: string;
    settingsDescriptionColumn: string;
    settingsEmptyMessage: string;
    settingsCloseButton: string;
  };

export const SERVICE_INTERFACE_MESSAGES: ServiceInterfaceMessages = {
  ...SERVICE_INTERFACE_FILTERS_MESSAGES,
  ...SERVICE_INTERFACE_TABLE_MESSAGES,
  ...SERVICE_INTERFACE_LOGS_MESSAGES,
  ...SIDEBAR_MESSAGES,
  pageTitle: "Integrações",
  tableTitle: "Listagem de integrações",
  integrationsBreadCrumb: "Integrações",
  errorToLoad: "Erro ao carregar integrações",
  noDataFoundError: "Nenhuma integração encontrada",
  noDataFoundAlt: "Sem integrações",
  settingsModalTitle: "Configurações da integração",
  settingsKeyColumn: "Chave",
  settingsValueColumn: "Valor",
  settingsDescriptionColumn: "Descrição",
  settingsEmptyMessage: "Nenhuma configuração disponível para esta integração.",
  settingsCloseButton: "Fechar",
};
